"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABEL_MODE = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Image = _interopRequireDefault(require("../Image"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LABEL_MODE = {
  labelDefault: "Default label on the bottom",
  labelRight: "label on the left",
  labelRightSmallerCircle: "label on the left smaller image"
};
exports.LABEL_MODE = LABEL_MODE;
Object.freeze(LABEL_MODE);
var defaultProps = {
  labelMode: LABEL_MODE.labelDefault,
  additionalLabel: false
};
var LabelWithImage = function LabelWithImage(props) {
  var image = props.image,
    url = props.url,
    _props$labelMode = props.labelMode,
    labelMode = _props$labelMode === void 0 ? defaultProps.labelMode : _props$labelMode,
    _props$additionalLabe = props.additionalLabel,
    additionalLabel = _props$additionalLabe === void 0 ? defaultProps.additionalLabel : _props$additionalLabe,
    id = props.id;
  var translations = {
    "new": (0, _langLibrary["default"])("new")
  };
  var label = props.label;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var circle = function circle(mode) {
    var mainCategoryCirclePercent = "80px";
    var subCategoryCirclePercent = "50px";
    var defaultCirclePercent = "100%";
    if (mode === LABEL_MODE.labelRight) {
      return mainCategoryCirclePercent;
    } else if (mode === LABEL_MODE.labelRightSmallerCircle) {
      return subCategoryCirclePercent;
    }
    return defaultCirclePercent;
  };
  var isDefaultLabel = labelMode === LABEL_MODE.labelDefault;
  var circleSize = circle(labelMode);
  var flexRowCss = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "nowrap"
  };
  var defaultColor = {
    color: "inherit"
  };
  var specialCategoryCss = {
    color: "negative"
  };
  var blackCategoryCss = {
    color: "white"
  };
  var boxingCategoryCss = {
    color: "white"
  };
  var sx = defaultColor;
  if (parseInt(id) === global.__appConfig__.specialCategoryId) {
    sx = specialCategoryCss;
  }
  if (parseInt(id) === global.__appConfig__.blackCategoryId) {
    sx = blackCategoryCss;
  }
  if (parseInt(id) === global.__appConfig__.boxingCategoryId) {
    sx = boxingCategoryCss;
  }
  var labelWithImage = __jsx(_Box["default"], {
    sx: _objectSpread({
      width: "100%",
      font: "xs_caps"
    }, sx)
  }, __jsx(_Box["default"], {
    sx: isDefaultLabel ? {} : flexRowCss
  }, image && __jsx(_Box["default"], {
    sx: {
      borderRadius: "50%",
      overflow: "hidden",
      position: "relative",
      flexBasis: circleSize,
      width: circleSize,
      height: circleSize,
      minWidth: circleSize
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1,
      objectFit: "cover"
    },
    image: image
  })), __jsx(_Box["default"], {
    sx: isDefaultLabel ? _objectSpread({
      mt: "s4",
      textAlign: "center",
      flexGrow: "1",
      alignItems: "center"
    }, flexRowCss) : {
      ml: image ? "s7" : "s0",
      flexGrow: "1",
      display: "flex",
      flexDirection: "row"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: labelMode === LABEL_MODE.labelDefault ? {
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": "3",
      overflow: "hidden",
      paddingLeft: "s5"
    } : {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      paddingLeft: "s5"
    }
  }, label), additionalLabel && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      minWidth: "50px"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      display: "block",
      ml: "s4",
      color: "main",
      minWidth: "2px",
      width: "2px",
      height: "2px",
      backgroundColor: "main"
    }
  }), __jsx(_Box["default"], {
    as: "p",
    sx: {
      display: "block",
      ml: "s4",
      color: "active"
    }
  }, translations["new"])))));
  return url ? __jsx(Link, {
    route: url
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, labelWithImage)) : labelWithImage;
};
var _default = LabelWithImage;
exports["default"] = _default;